import type { LightningReportTypeRules } from '@xweather/protect-types'
import type { SubscriptionEntity } from '../../api/service-manager.ts'
import { nldnBoundaryPolygon } from './nldnCoverage.ts'

type SubscriptionFeature = SubscriptionEntity['features'][number]

// Temporary stand-in for the lightning rules of GET /v2/analyze/report-types; remove it once the frontend reads them from there.
export const localLightningReportTypeRules = (features: readonly SubscriptionFeature[]): LightningReportTypeRules => ({
	allowUnprotectedAssets: features.includes('analyze-allow-unprotected-assets'),
	maxAssets: 1,
	maxVertexCount: 500,
	minDuration: 'PT0.001S',
	maxDurationByArea: [
		{ upToAreaKm2: 2000, maxDuration: 'P31D' },
		{ upToAreaKm2: 10_000, maxDuration: 'P14D' },
		{ upToAreaKm2: 40_000, maxDuration: 'P7D' },
		{ upToAreaKm2: 160_000, maxDuration: 'P2D' },
		{ upToAreaKm2: 1_000_000, maxDuration: 'P1D' },
	],
	downloadFormats: [
		{ format: 'pdf', name: 'PDF' },
		{ format: 'csv', name: 'CSV' },
		{ format: 'geojson', name: 'GeoJSON' },
		{ format: 'json', name: 'JSON' },
	],
	durationTolerance: 'PT2H',
	scheduleReportDurations: { DAILY: 'P1D', WEEKLY: 'P7D', MONTHLY: 'P31D' },
	coverageZones: {
		MERGE: { geometry: null },
		...(features.includes('analyze-nldn-dataset') ? { NLDN: { geometry: nldnBoundaryPolygon } } : {}),
	},
	errorEllipses: features.includes('analyze-error-ellipses'),
	strikeDamagePotential: features.includes('analyze-strike-damage-potential'),
})
